export default __webpack_public_path__ + "static/media/agility-preset.43d92605.svg";